import React, { useState } from 'react';
import rolodexLogo from './assets/rolodex.webp';
import { api } from './api';
import { Link } from 'react-router-dom';
import { accountRecoveryEnabled } from './features';

function Login({ onLogin }) {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/v1/auth/login', {
        identifier,
        password
      });

      // store token
      localStorage.setItem('token', res.data.token);
      onLogin && onLogin();
    } catch (err) {
      setError('Invalid username or password');
    }
  };

  return (
    
    <div className="auth-screen" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      gap: 50
    }}>
      <div className="auth-brand">
        <img
            src={rolodexLogo}
            alt="Digidex Logo"
            className="auth-logo"
            style={{ height: '7.5rem', width: '7.5rem', objectFit: 'contain' }}
          />
        <h1 style={{
          fontSize: '2.15rem',
          fontWeight: 'bold',
          color: '#333'
        }}>Digidex</h1>
      </div>
      <form
        onSubmit={handleSubmit}
        className="auth-form"
        style={{
          background: '#fff',
          padding: '2rem 2.5rem',
          borderRadius: '10px',
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
          minWidth: '320px',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <h2 style={{ textAlign: 'center', marginBottom: '1rem', color: '#222' }}>Login</h2>
        {error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}
        <input
          placeholder="Username or email"
          value={identifier}
          onChange={e => setIdentifier(e.target.value)}
          required
          style={{
            padding: '0.75rem',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontSize: '1rem',
            background: '#fafafa',
            outline: 'none',
            transition: 'border 0.2s',
          }}
        />
        <input
          placeholder="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{
            padding: '0.75rem',
            border: '1px solid #ddd',
            borderRadius: '5px',
            fontSize: '1rem',
            background: '#fafafa',
            outline: 'none',
            transition: 'border 0.2s',
          }}
        />
        <button
          type="submit"
          style={{
            padding: '0.75rem',
            border: 'none',
            borderRadius: '5px',
            background: '#222',
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '1rem',
            cursor: 'pointer',
            marginTop: '0.5rem',
            transition: 'background 0.2s',
          }}
        >
          Login
        </button>
        {accountRecoveryEnabled && <Link to="/forgot-password" style={{ textAlign: 'center', color: '#222' }}>Forgot password?</Link>}
        {accountRecoveryEnabled && <Link to="/recover-username" style={{ textAlign: 'center', color: '#222' }}>Forgot username?</Link>}
        <Link to="/register" style={{ textAlign: 'center', color: '#222', fontWeight: 'bold' }}>Create an account</Link>
      </form>
    </div>
  );
}

export default Login;
